<template>
  <div id="landing">
    <nav
      class="d-none d-sm-block navbar row navbar-expand-md navbar-light bg-light fixed-top effect-main"
    >
      <div class="container container-s">
        <div class="row">
          <div class="col-4">
            <img class="logo" src="/static/images/logo_full.svg" alt />
          </div>
          <div class="col">
            <ul class="header-menu">
              <li>
                <a href="#benefits">{{$t('landing.topMenu.benefits')}}</a>
              </li>
              <li>
                <a href="#features">{{$t('landing.topMenu.features')}}</a>
              </li>
              <li>
                <a href="#thesis">{{$t('landing.topMenu.thesis')}}</a>
              </li>
              <li>
                <a href="#pricing">{{$t('landing.topMenu.pricing')}}</a>
              </li>
              <li>
                <a href="login">{{$t('landing.topMenu.login')}}</a>
              </li>
              <li>
                <base-button
                  @click="goToRegistration"
                  :text="$t('landing.registration.buttonText')"
                  class="nav-registration-button"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div class="row section-row">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <img class="illustration_1" src="/static/images/download.svg" alt />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h1>{{$t('landing.header.title')}}</h1>
            <p class="grey-text">{{$t('landing.header.subtitle')}}</p>
            <p>
              <a class="d-sm-none mobile-login" href="login">{{$t('landing.header.mobileLogin')}}</a>
            </p>
            <p>
              <base-button
                @click="goToRegistration"
                :text="$t('landing.header.buttonText')"
                class="registration-button"
              />
            </p>
            <p>
              <a
                href="https://www.producthunt.com/posts/motivac-io?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-motivac-io"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=171416&theme=dark"
                  alt="motivac.io - Build better synergies between your employees | Product Hunt Embed"
                  style="width: 250px; height: 54px;"
                  width="250px"
                  height="54px"
                />
              </a>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="szm-section">
              <div class="row">
                <div class="col-xl-4 col-12">
                  <a href="https://szerethetomunkahelyek.hu/" target="_blank">
                    <img class="szm-logo" src="static/images/szm_logo.png" alt />
                  </a>
                </div>
                <div class="col-xl-8 col-12">
                  <h2>{{$t('landing.szm.title')}}</h2>
                  <p v-html="$t('landing.szm.description')"></p>
                  <p>
                    <base-button
                      @click="goToRegistration"
                      :text="$t('landing.szm.buttonText')"
                      class="registration-button"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row color-row section-row" id="benefits">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h1>{{$t('landing.benefits.title')}}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 benefit col-xs-1" v-for="index in 6" :key="index">
            <div class="row">
              <font-awesome-icon
                class="benefit-icon"
                :icon="$t(`landing.benefits.${index}.icon`)"
                size="4x"
              />
            </div>
            <div class="row">
              <div class="col-12">
                <h3>{{$t(`landing.benefits.${index}.title`)}}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-12 benefit-text">{{$t(`landing.benefits.${index}.description`)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row section-row features" id="features">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h1>{{$t('landing.features.title')}}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-12 video-col">
            <video controls autoplay loop id="mobile-demo">
              <source src="/static/videos/mobile.mp4" type="video/mp4" />
            </video>
            <div class="mobile-subtitle" v-html="$t('landing.features.mobile')"></div>
          </div>
          <div class="col-lg-8 features-col col-12">
            <carousel
              class="carousel features"
              :center="true"
              :dots="true"
              :nav="false"
              :autoplay="true"
              :autoWidth="false"
              :responsive="responsive"
            >
              <div v-for="index in 4" :key="index">
                <div class="row feature">
                  <div class="col-12">
                    <h3>{{$t(`landing.features.${index}.title`)}}</h3>
                    <p class="feature-text">{{$t(`landing.features.${index}.description`)}}</p>
                  </div>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="row section-row reviews" id="thesis">
      <div class="col-12">
        <h1>{{$t('landing.thesis.title')}}</h1>
        <div class="review">
          <div class="row">
            <div class="col-12 col-md-6">
              <img
                class="reviewer-image"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToBxsr7pJwWgncBVTX0thXFdwEEsR-QsodYpWRfFWgbF-Ot6pjzQ"
                alt
              />
            </div>
            <div class="col-12 col-md-6">
              <div class="review-text">
                {{$t('landing.thesis.quote')}}
                <div class="review-name">
                  DANIEL H. PINK
                  <br />
                  {{$t('landing.thesis.author')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row section-row pricing" id="pricing">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h1>{{$t($t('landing.pricing.title'))}}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="basic-box pricing-box">
              <h2>{{$t('landing.pricing.free.title')}}</h2>
              <p class="subtitle">{{$t('landing.pricing.free.description')}}</p>
              <p class="price">€0.00</p>
              <p class="limit">{{$t('landing.pricing.free.limitation')}}</p>
              <base-button
                @click="goToRegistration"
                :text="$t('landing.pricing.free.buttonText')"
                class="registration-button"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="basic-box pricing-box">
              <h2>{{$t('landing.pricing.pioneer.title')}}</h2>
              <p class="subtitle">{{$t('landing.pricing.pioneer.description')}}</p>
              <p class="price">€3.00</p>
              <p class="limit">{{$t('landing.pricing.pioneer.limitation')}}</p>
              <base-button
                @click="goToRegistration"
                :text="$t('landing.pricing.pioneer.buttonText')"
                class="registration-button"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer v-html="$t('landing.footer.title')"></footer>
  </div>
</template>

<script>
/* eslint-disable */
import BaseButton from '@/components/shared/elements/BaseButton';
import SignUpModal from '@/components/shared/modals/SignUpModal';
import RegistrationModal from '@/components/shared/modals/RegistrationModal';

export default {
  name: 'LandingScreen',
  components: {
    BaseButton,
  },
  data() {
    return {
      responsive: {
        0: {
          items: 1,
        },
      },
    };
  },
  created() {
    this.initializeOptiMonk();
    this.initializeCrisp();
  },
  methods: {
    goToRegistration() {
      this.$eventBus.showModal({
        bind: {
          is: RegistrationModal,
        },
      });
    },
    initializeOptiMonk() {
      (function (e, a) {
        let t,
          r = e.getElementsByTagName('head')[0],
          c = e.location.protocol;
        t = e.createElement('script');
        t.type = 'text/javascript';
        t.charset = 'utf-8';
        t.async = !0;
        t.defer = !0;
        t.src = `${c }//front.optimonk.com/public/${ a }/js/preload.js`;
        r.appendChild(t);
      }(document, '79957'));
    },
    initializeCrisp() {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = 'fe146345-bb24-4a3e-8e0f-402286c6f035';
      (function () {
        const d = document;
        const s = d.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = 1;
        d.getElementsByTagName('head')[0].appendChild(s);
      }());
    },
  },
};
</script>


<style lang="scss" scoped>
#landing {
  .navbar {
    z-index: 2;
    .logo {
      max-height: 30px;
    }
    padding-top: 10px;
    padding-bottom: 10px;
    .header-menu {
      margin-left: auto !important;
      vertical-align: baseline;
      flex-direction: row;
      list-style: none;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      padding-left: 0;
      margin-bottom: 0;
      list-style: none;
      align-items: center;
      justify-content: center;
      li {
        margin-top: 0;
        margin-right: 15px;
        font-size: 0.85rem;
        font-weight: 400;
        list-style: none;
        cursor: pointer;
        a {
          color: $base-font-color;
          &:hover {
            color: $primary-hover-color;
          }
        }
      }
    }
  }
  .mobile-login {
    display: block;
    margin: 20px 0;
  }
  .grey-text {
    opacity: 0.75;
  }
  .illustration_1 {
    margin: 10%;
    max-width: 70%;
  }
  .registration-button {
    max-width: 250px;
    margin: 0 auto;
  }
  .section-row {
    padding: 5% 20%;
  }
  @media only screen and (max-width: 600px) {
    .section-row {
      padding: 5% 10%;
    }
  }
  .color-row {
    background-color: #f6f6fd;
  }
  .benefit {
    text-align: center;
    padding: 2%;
    .benefit-icon {
      margin: 20px auto;
      height: 50px;
      width: 50px;
      padding: 15px;
      color: $primary-color;
      border-radius: 50%;
      border: 1px solid $primary-color;
    }
    .benefit-text {
      opacity: 0.75;
    }
  }
  .features {
    position: relative;
    &.carousel {
      width: 100%;
    }
    .feature {
      max-width: 600px;
      margin: 0 auto;
      .feature-image {
        width: unset;
        max-height: 150px;
      }
      .feature-text {
        opacity: 0.75;
      }
    }
  }
  .reviews {
    background-color: $primary-color;
    color: white;
    h1 {
      margin-bottom: 10px;
    }
    .review {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      .review-text {
        text-align: left;
        margin: 10px;
        font-size: 20px;
        font-style: italic;
        .review-name {
          margin: 10px 0;
          font-style: unset !important;
          font-weight: bolder;
          font-size: 16px;
        }
      }
      .reviewer-image {
        width: 150px;
        height: 150px;
        border-radius: 75px;
        margin: 10px;
      }
    }
  }
  .pricing {
    h1 {
      margin-bottom: 10px;
    }
    .pricing-box {
      margin-top: 10px;
      .subtitle {
        font-size: 12px;
        opacity: 0.75;
      }
      .price {
        font-size: 32px;
        color: $primary-hover-color;
        margin: 50px 0;
      }
      .limit {
        opacity: 0.75;
        margin: 0 10px;
      }
      .registration-button {
        font-size: 12px;
        margin: 20px auto;
      }
    }
    .discount {
      text-decoration: line-through;
    }
  }
  footer {
    font-size: 12px;
    opacity: 0.75;
    a {
      color: $primary-color;
    }
    p {
      margin-bottom: 0;
    }
  }
  .announcement {
    background: rgb(51, 128, 195);
    background: linear-gradient(
      90deg,
      rgba(51, 128, 195, 1) 0%,
      rgba(98, 45, 144, 1) 49%
    );
    color: white;
    border-radius: 8px;
    padding: 20px;
    .registration-button {
      margin-top: 20px;
      border: 2px solid white;
      border-radius: 8px;
    }
  }
  #mobile-demo {
    max-height: 500px;
    border: 8px solid #ccc;
    border-radius: 8px;
  }
  .video-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .features-col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mobile-subtitle {
    font-size: 12px;
  }
  @media (max-width: 992px) {
    .mobile-subtitle {
      visibility: hidden;
    }
  }
  .szm-section {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    margin-top: 40px;
    div[class*="col-"] {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .szm-logo {
      height: 150px;
    }
  }
}
</style>
